module.exports = __webpack_public_path__ + "img/error.5bec5c43.jpg";